type CouponDataPayload = {
  couponCode: string;
};

type CouponResponse =
  | {
      status: 'success';
      discount: number;
      discountType: 'percentage' | 'fixed';
    }
  | {
      status: 'already_applied' | 'not_found' | 'server_error';
      error: string;
    };

const statusMap = {
  400: 'already_applied',
  404: 'not_found',
  500: 'server_error',
} as const;
const ENABLED = false;

export async function applyCoupon(
  data: CouponDataPayload
): Promise<CouponResponse> {
  if (!ENABLED) {
    await new Promise((resolve) => setTimeout(resolve, 1500));

    if (data.couponCode === 'WRONG') {
      return { status: 'not_found', error: 'Coupon not found' };
    }

    return { status: 'success', discount: 50, discountType: 'fixed' };
  }

  const response = await fetch('/api/coupon', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Failed to apply coupon');
  }

  return response.json();
}
